import React from 'react';

import { Box } from '@betterment/samba-react';

const Column: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Box
    css={{
      display: 'flex',
      flexDirection: 'column',
      gap: 'space.100',
    }}
  >
    {children}
  </Box>
);

export default Column;
